var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"box",on:{"mousedown":_vm.sbuMousedown}},_vm._l((_vm.list),function(item,index){return _c('img',{key:index,class:_vm.listIndex == index?'show':'',attrs:{"src":item}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }